<template>
  <div class="container-collapsible">
    <div class="row">
      <CollapseControllerSummaryNew :showTimeSelection="false" :fullscreen="false" />
    </div>
    <div class="row">
      <DropdownCalendar
        v-if="dateSelections"
        id="calendar-open-button"
        :dateSelection="dateSelections"
        :defaultSelection="defaultSelection"
        @presentCalendar="$emit('present-calendar')"
      />
      <AccordionText
        id="collapse-toggle-button"
        :active="!isCollapsed"
        :size="'small'"
        :accordionText="label"
        @onClicked="$emit('toggle-collapse')"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import CollapseControllerSummaryNew from './CollapseControllerSummaryNew.vue'
import { useI18n } from 'vue-i18n'
import AccordionText from '@/design-system/atoms/AccordionText.vue'
import DropdownCalendar from '@/design-system/molecules/DropdownCalendar.vue'
import { useFeature } from '@/pinia/features'
import { computed } from 'vue'
import { DateSelection } from '@/interfaces/dateselection.interface'
import { DateTimeRange } from '@/composables/useTimeRange'
import { LocaleString } from '@/components/types'

const { t } = useI18n()
const { feature } = useFeature('home/*/*/*/time')
type Props = {
  isCollapsed: boolean
  showCalendar: boolean
  defaultSelection: string
}
type Emits = {
  (e: 'toggle-collapse')
  (e: 'present-calendar')
}
defineProps<Props>()
defineEmits<Emits>()
const label = t('general__text__dashboard_change_filtering')

const dateSelections = computed(() =>
  feature.value?.children?.map(
    (child): DateSelection => ({
      name: child.name,
      title: child.title,
      access: child.access as string[],
      range: child.props.range as DateTimeRange,
      icon: child.props.icon as LocaleString
    })
  )
)
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.container-collapsible {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  margin-top: 8px;
}
.container-collapsible .row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: variables.$padding-medium;
  align-items: center;
}
#collapse-toggle-button {
  height: 32px;
  white-space: nowrap;
}
#calendar-open-button {
  margin-top: 8px;
}
.icon {
  transform: rotate(180deg);
}
.rotated {
  transform: rotate(0deg);
}
button {
  border: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: variables.$color-primary;
  gap: variables.$padding-medium;
  @include font-mixins.desktop-bold-label;
  height: variables.$button-small;
  span {
    white-space: nowrap;
  }
  &:hover {
    color: variables.$color-primary-dark;
  }
}
</style>
